import { useEffect, useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";

export default function Tips() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12" data-testid="tips-page">
      <SEO title="Training Tips & Coaching" path="/tips"
        description="Endurance running training tips from OSCR's coaching desk — pacing, nutrition, injury prevention, race strategy. Written for Odisha's climate and terrain. Updated regularly." />
      <p className="font-mono text-[11px] tracking-[0.3em] text-orange-500 uppercase">FROM THE COACH</p>
      <h1 className="font-display text-4xl sm:text-6xl text-white mt-2">Training Tips</h1>
      <p className="text-zinc-400 mt-3 max-w-2xl leading-relaxed">
        Insights from the OSCR coaching desk — pacing strategies, hydration in humid Odisha
        summers, injury prevention, strength work for runners, fuelling long runs, race-day
        nutrition and recovery. Written specifically for our climate, terrain and the way
        Odisha trains. Updated regularly with field-tested advice from our founder, 2× Guinness
        World Record holder Sumit Kumar Singh, and guest contributors.
      </p>

      <div className="mt-10 space-y-4">
        {posts.length === 0 && (
          <div className="hairline bg-zinc-900 p-8 text-center text-zinc-500 font-mono text-sm">No tips published yet.</div>
        )}
        {posts.map((p) => (
          <article key={p.blog_id} className="hairline bg-zinc-900 p-6">
            <p className="font-mono text-[10px] tracking-[0.3em] text-orange-500 uppercase">
              {new Date(p.created_at).toDateString()} · {p.author}
            </p>
            <h2 className="font-display text-3xl text-white mt-2">{p.title}</h2>
            {p.image && <img src={p.image} alt="" className="mt-4 max-h-96 w-full object-cover hairline" />}
            <p className="text-zinc-300 mt-4 whitespace-pre-wrap leading-relaxed">{p.content}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
